import React, { useEffect, useState } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import { loggedUserAtom } from "../../data/store";
import routes from "../../data/constants/routes";
import PageLoader from "../PageLoader/PageLoader";

const CheckIfLoggedIn = () => {
	const [loggedUser] = useAtom(loggedUserAtom);
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const [isReady, setIsReady] = useState(false);

	// Wait for jotai to hydrate from localStorage
	// atomWithStorage needs a brief moment to sync with localStorage on mount
	useEffect(() => {
		// Small delay to allow jotai's atomWithStorage to hydrate
		const timer = setTimeout(() => {
			setIsReady(true);
		}, 100);

		return () => clearTimeout(timer);
	}, []);

	// Handle navigation after hydration is complete
	useEffect(() => {
		if (!isReady) return;

		const isAuthenticated = loggedUser && Object.keys(loggedUser).length !== 0;
		const isAuthRoute = pathname === "/" || pathname === routes.ADMIN_LOGIN;

		if (isAuthenticated) {
			// User is logged in - redirect away from auth pages
			if (isAuthRoute) {
				navigate(routes.ADMIN_HOME, { replace: true });
			}
			// Otherwise, stay on current route (don't force navigation)
		} else {
			// User is not logged in - redirect to login (unless already there)
			if (pathname !== routes.ADMIN_LOGIN) {
				navigate(routes.ADMIN_LOGIN, { replace: true });
			}
		}
	}, [isReady, loggedUser, pathname, navigate]);

	return isReady ? <Outlet /> : <PageLoader />;
};

export default CheckIfLoggedIn;
